/**
 * Oudamir – Frontend Currency Converter
 * Display-only multi-currency for GCC countries.
 * Checkout always remains in AED.
 */
(function () {
  'use strict';

  /* ─── Configuration ─── */
  var STORAGE_KEY = 'oudamir_currency';
  var BASE_CURRENCY = 'AED';

  var CURRENCIES = {
    AED: { rate: 1, symbol: 'AED', decimals: 0, flag: '🇦🇪', name: 'UAE' },
    SAR: { rate: 1.02, symbol: 'SAR', decimals: 0, flag: '🇸🇦', name: 'Saudi Arabia' },
    QAR: { rate: 0.99, symbol: 'QAR', decimals: 0, flag: '🇶🇦', name: 'Qatar' },
    KWD: { rate: 0.083, symbol: 'KWD', decimals: 0, flag: '🇰🇼', name: 'Kuwait' },
    BHD: { rate: 0.103, symbol: 'BHD', decimals: 0, flag: '🇧🇭', name: 'Bahrain' },
    OMR: { rate: 0.105, symbol: 'OMR', decimals: 0, flag: '🇴🇲', name: 'Oman' }
  };

  /* ─── State ─── */
  var currentCurrency = BASE_CURRENCY;
  var debounceTimer = null;

  /* ─── Helpers ─── */

  /**
   * Extract numeric value from a price string.
   * Handles: "Dhs. 149.00", "AED 149.00", "149.00 AED", "14,900.00", "135 AED"
   */
  function extractPrice(text) {
    if (!text) return null;
    var matches = text.match(/(\d[\d,]*\.?\d*)/g);
    if (!matches || matches.length === 0) return null;
    var best = 0;
    for (var i = 0; i < matches.length; i++) {
      var val = parseFloat(matches[i].replace(/,/g, ''));
      if (!isNaN(val) && val > best) best = val;
    }
    return best > 0 ? best : null;
  }

  /**
   * Format a number as a price string with currency code (whole numbers only).
   */
  function formatPrice(amount, currencyCode) {
    var c = CURRENCIES[currencyCode] || CURRENCIES[BASE_CURRENCY];
    var rounded = Math.round(amount);
    var formatted = rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formatted + ' ' + c.symbol;
  }

  /**
   * Get all text nodes inside an element (for deep nested prices).
   */
  function getDeepText(el) {
    return el.textContent || el.innerText || '';
  }

  /* ─── Core ─── */

  /**
   * Convert all prices on the page.
   * Strategy: find ALL elements that display prices and convert them.
   */
  function convertAllPrices(targetCurrency) {
    /* 1. Standard Dawn price items */
    document.querySelectorAll('.price-item').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 2. Oudamir custom card prices */
    document.querySelectorAll('.oudamir-card__price').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 3. Cart totals */
    document.querySelectorAll('.totals__total-value').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 4. Bundle prices on product page */
    document.querySelectorAll('.oudamir-bundle__price').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 5. Volume pricing / price-per-item */
    document.querySelectorAll('.price-per-item--current').forEach(function (el) {
      processElement(el, targetCurrency);
    });
    document.querySelectorAll('.variant-item__old-price').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 6. Cart line item prices */
    document.querySelectorAll('.cart-item__totals .price').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 7. Subtotal */
    document.querySelectorAll('.totals__subtotal-value').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 8. Cart item individual price */
    document.querySelectorAll('.cart-item__details .price').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 9. Quick add / featured collection card prices */
    document.querySelectorAll('.card-information .price .money').forEach(function (el) {
      processElement(el, targetCurrency);
    });

    /* 10. Any element with money class inside a price container */
    document.querySelectorAll('.price .money').forEach(function (el) {
      processElement(el, targetCurrency);
    });
  }

  /**
   * Process a single element: store original, convert, update text.
   */
  function processElement(el, targetCurrency) {
    /* Store original price (only once, from initial AED value) */
    if (!el.hasAttribute('data-original-price')) {
      var text = getDeepText(el);
      var price = extractPrice(text);
      if (price !== null && price > 0) {
        el.setAttribute('data-original-price', price.toString());
        el.setAttribute('data-original-html', el.innerHTML);
      } else {
        return; /* Skip elements with no valid price */
      }
    }

    var originalAED = parseFloat(el.getAttribute('data-original-price'));
    if (isNaN(originalAED) || originalAED <= 0) return;

    if (targetCurrency === BASE_CURRENCY) {
      /* Restore original HTML */
      var origHTML = el.getAttribute('data-original-html');
      if (origHTML) {
        el.innerHTML = origHTML;
      }
    } else {
      var cfg = CURRENCIES[targetCurrency];
      if (!cfg) return;
      var converted = originalAED * cfg.rate;
      el.textContent = formatPrice(converted, targetCurrency);
    }
  }

  /**
   * Update the trigger button displays (both desktop & mobile).
   */
  function updateTriggerButtons(currencyCode) {
    var cfg = CURRENCIES[currencyCode];
    if (!cfg) return;

    document.querySelectorAll('.oudamir-currency__trigger').forEach(function (trigger) {
      var flagEl = trigger.querySelector('.oudamir-currency__flag');
      var codeEl = trigger.querySelector('.oudamir-currency__code');
      if (flagEl) flagEl.textContent = cfg.flag;
      if (codeEl) codeEl.textContent = cfg.symbol;
    });

    document.querySelectorAll('.oudamir-currency__option').forEach(function (option) {
      var optCode = option.getAttribute('data-currency-code');
      if (optCode === currencyCode) {
        option.classList.add('is-active');
      } else {
        option.classList.remove('is-active');
      }
    });
  }

  /**
   * Show/hide the AED checkout notice.
   */
  function updateCheckoutNotice(currencyCode) {
    document.querySelectorAll('.oudamir-aed-notice').forEach(function (notice) {
      notice.style.display = currencyCode === BASE_CURRENCY ? 'none' : 'block';
    });
  }

  /**
   * Main switch function.
   */
  function switchCurrency(currencyCode) {
    if (!CURRENCIES[currencyCode]) return;
    currentCurrency = currencyCode;

    try { localStorage.setItem(STORAGE_KEY, currencyCode); } catch (e) {}

    convertAllPrices(currencyCode);
    updateTriggerButtons(currencyCode);
    updateCheckoutNotice(currencyCode);
  }

  /* ─── MutationObserver ─── */
  function startObserver() {
    if (typeof MutationObserver === 'undefined') return;

    var observer = new MutationObserver(function () {
      if (currentCurrency === BASE_CURRENCY) return;

      /* Debounce: wait 200ms after last DOM change */
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        /* Re-scan for new price elements that don't have data-original-price yet */
        convertAllPrices(currentCurrency);
      }, 200);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /* ─── Click Handlers ─── */
  function initSelectors() {
    document.addEventListener('click', function (e) {
      var option = e.target.closest('.oudamir-currency__option');
      if (!option) return;

      var code = option.getAttribute('data-currency-code');
      if (code && CURRENCIES[code]) {
        e.preventDefault();
        e.stopPropagation();
        switchCurrency(code);

        /* Close dropdown */
        var dropdown = option.closest('.oudamir-currency__dropdown');
        if (dropdown) {
          dropdown.classList.remove('is-open');
          dropdown.setAttribute('aria-hidden', 'true');
        }
        var trigger = option.closest('.oudamir-currency').querySelector('.oudamir-currency__trigger');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      }
    });
  }

  /* ─── Boot ─── */
  function init() {
    /* Restore saved currency */
    try {
      var saved = localStorage.getItem(STORAGE_KEY);
      if (saved && CURRENCIES[saved]) {
        currentCurrency = saved;
      }
    } catch (e) {}

    /* Initial conversion if non-AED */
    if (currentCurrency !== BASE_CURRENCY) {
      convertAllPrices(currentCurrency);
      updateTriggerButtons(currentCurrency);
      updateCheckoutNotice(currentCurrency);
    }

    initSelectors();
    startObserver();
  }

  /* Expose globally */
  window.OudamirCurrency = {
    switch: switchCurrency,
    getCurrent: function () { return currentCurrency; },
    getConfig: function () { return CURRENCIES; }
  };

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
